import { render, staticRenderFns } from "./VModalRemarkRejectionReset.vue?vue&type=template&id=68693ff3&"
import script from "./VModalRemarkRejectionReset.vue?vue&type=script&lang=ts&"
export * from "./VModalRemarkRejectionReset.vue?vue&type=script&lang=ts&"
import style0 from "./VModalRemarkRejectionReset.vue?vue&type=style&index=0&id=68693ff3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports